import React from "react";

const SHAPES = {
  circle: (color) => (
    <circle cx="12" cy="12" r="9" fill={color} />
  ),
  square: (color) => (
    <rect x="4" y="4" width="16" height="16" rx="2" fill={color} />
  ),
  diamond: (color) => (
    <rect
      x="6.2"
      y="6.2"
      width="11.6"
      height="11.6"
      rx="1.5"
      fill={color}
      transform="rotate(45 12 12)"
    />
  ),
};

function TrailMarker({ shape = "circle", color = "#2d4a35", size = 22, className }) {
  const draw = SHAPES[shape] || SHAPES.circle;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      aria-hidden="true"
    >
      {draw(color)}
    </svg>
  );
}

export default TrailMarker;
